import { fetch } from '@/common/request';

// MCP Server 配置
export interface McpServerConfigVo {
  id: number;
  serverName: string;
  displayName?: string;
  description?: string;
  serverUrl: string;
  transportType?: string;
  authType?: string;
  authConfig?: Record<string, any>;
  connectTimeout?: number;
  requestTimeout?: number;
  status: number;
  toolCount?: number;
  online?: boolean;
  lastSyncAt?: string;
  syncStatus?: string;
  syncError?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface McpServerConfigCreateReq {
  serverName: string;
  displayName?: string;
  description?: string;
  serverUrl: string;
  transportType?: string;
  authType?: string;
  authConfig?: Record<string, any>;
  connectTimeout?: number;
  requestTimeout?: number;
}

export interface McpServerConfigUpdateReq {
  id: number;
  displayName?: string;
  description?: string;
  serverUrl?: string;
  authType?: string;
  authConfig?: Record<string, any>;
  connectTimeout?: number;
  requestTimeout?: number;
  status?: number;
}

// Tool Registry
export interface ToolRegistryVo {
  id: number;
  toolName: string;
  displayName?: string;
  description?: string;
  category?: string;
  mcpServerId?: number;
  inputSchema?: string;
  tags?: string;
  version?: string;
  status: number;
  source: string;
  isGlobal?: number;
  createdAt?: string;
  updatedAt?: string;
}

// 连接测试结果
export interface ConnectionTestResult {
  success: boolean;
  online: boolean;
  toolCount?: number;
  message?: string;
  error?: string;
}

// 同步结果
export interface SyncResult {
  success: boolean;
  toolCount?: number;
  message?: string;
  error?: string;
}

// MCP Server API
export function getMcpServerList(): Promise<McpServerConfigVo[]> {
  return fetch('/api/mcp-server/list', { method: 'GET' }, true);
}

export function getMcpServerActiveList(): Promise<McpServerConfigVo[]> {
  return fetch('/api/mcp-server/active', { method: 'GET' }, true);
}

export function getMcpServerDetail(id: number): Promise<McpServerConfigVo> {
  return fetch(`/api/mcp-server/${id}`, { method: 'GET' }, true);
}

export function createMcpServerConfig(params: McpServerConfigCreateReq): Promise<number> {
  return fetch(
    '/api/mcp-server/create',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updateMcpServerConfig(params: McpServerConfigUpdateReq): Promise<void> {
  return fetch(
    '/api/mcp-server/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function deleteMcpServerConfig(id: number): Promise<void> {
  return fetch(`/api/mcp-server/delete/${id}`, { method: 'POST' }, true);
}

export function testMcpServerConnection(id: number): Promise<ConnectionTestResult> {
  return fetch(`/api/mcp-server/test/${id}`, { method: 'GET' }, true);
}

export function syncMcpServerTools(id: number): Promise<SyncResult> {
  return fetch(`/api/mcp-server/sync/${id}`, { method: 'POST' }, true);
}

export function reconnectMcpServer(id: number): Promise<SyncResult> {
  return fetch(`/api/mcp-server/reconnect/${id}`, { method: 'POST' }, true);
}

export function getMcpServerTools(serverId: number): Promise<ToolRegistryVo[]> {
  return fetch(`/api/mcp-server/tools/${serverId}`, { method: 'GET' }, true);
}